<script setup>
import Icon from "@/components/icons/Icon.vue";

const model = defineModel();

defineProps({
  id: {
    type: String,
    required: true
  },
  name: {
    type: String,
    default: ''
  },
  srLabel: {
    type: String,
    required: true
  },
  value: {
    type: [String, Number, Boolean, Object],
    required: true
  }
});

const emit = defineEmits(['change']);

function handleChange(event) {
  emit('change', event);
}
</script>

<template>
  <div class="jwx-checkbox-control">
    <input
      type="checkbox"
      :name="name"
      :id="id"
      :value="value"
      v-model="model" 
      @change="handleChange"
      class="jwx-checkbox-control__input jwx-hidden-control"
    />
    <label :for="id" class="jwx-checkbox-control__label">
      <p class="sr-only">{{ srLabel }}</p>
      <div class="jwx-checkbox-control__indicator">
        <Icon name="checkmark" class="jwx-checkbox-control__indicator-icon" />
      </div>
    </label>
  </div>
</template>
